// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner_wrapper__QvH4T","logo":"spinner_logo__8byGw","spinner":"spinner_spinner__6Hzr7","spin":"spinner_spin__rQPhQ"};